// @ts-nocheck
import React from "react";
import { Typography, useTheme } from "@mui/material";
import {
  LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from "recharts";

const data = [
  { name: "Jan", uv: 4000, pv: 2400, amt: 2400 },
  { name: "Feb", uv: 3000, pv: 1398, amt: 2210 },
  { name: "Mar", uv: 2000, pv: 9800, amt: 2290 },
  { name: "Apr", uv: 2780, pv: 3908, amt: 2000 },
  { name: "May", uv: 1890, pv: 4800, amt: 2181 },
  { name: "Jun", uv: 2390, pv: 3800, amt: 2500 },
  { name: "Jul", uv: 3490, pv: 4300, amt: 2100 },
];

const pieData = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 300 },
  { name: "Group C", value: 300 },
  { name: "Group D", value: 200 },
];

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const RechartsTestPage = () => {
  const theme = useTheme();
  const fontColor = theme.palette.text?.primary || '#fff';
  const tooltipBg = '#222';
  return (
    <div style={{ padding: 24 }}>
      <Typography variant="h4" gutterBottom>Recharts Test Page</Typography>
      <div style={{ width: "100%", height: 300 }}>
        <Typography variant="h6" gutterBottom>Line Chart</Typography>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#444" />
            <XAxis dataKey="name" tick={{ fill: fontColor }} axisLine={{ stroke: fontColor }} tickLine={{ stroke: fontColor }} />
            <YAxis tick={{ fill: fontColor }} axisLine={{ stroke: fontColor }} tickLine={{ stroke: fontColor }} />
            <Tooltip contentStyle={{ backgroundColor: tooltipBg, color: fontColor, border: `1px solid ${fontColor}` }} itemStyle={{ color: fontColor }} labelStyle={{ color: fontColor }} />
            <Legend wrapperStyle={{ color: fontColor }} />
            <Line type="monotone" dataKey="pv" stroke="#8884d8" />
            <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div style={{ width: "100%", height: 300, marginTop: 40 }}>
        <Typography variant="h6" gutterBottom>Bar Chart</Typography>
        <ResponsiveContainer>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#444" />
            <XAxis dataKey="name" tick={{ fill: fontColor }} axisLine={{ stroke: fontColor }} tickLine={{ stroke: fontColor }} />
            <YAxis tick={{ fill: fontColor }} axisLine={{ stroke: fontColor }} tickLine={{ stroke: fontColor }} />
            <Tooltip contentStyle={{ backgroundColor: tooltipBg, color: fontColor, border: `1px solid ${fontColor}` }} itemStyle={{ color: fontColor }} labelStyle={{ color: fontColor }} />
            <Legend wrapperStyle={{ color: fontColor }} />
            <Bar dataKey="pv" fill="#8884d8" />
            <Bar dataKey="uv" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div style={{ width: "100%", height: 300, marginTop: 40 }}>
        <Typography variant="h6" gutterBottom>Area Chart</Typography>
        <ResponsiveContainer>
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis dataKey="name" tick={{ fill: fontColor }} axisLine={{ stroke: fontColor }} tickLine={{ stroke: fontColor }} />
            <YAxis tick={{ fill: fontColor }} axisLine={{ stroke: fontColor }} tickLine={{ stroke: fontColor }} />
            <CartesianGrid strokeDasharray="3 3" stroke="#444" />
            <Tooltip contentStyle={{ backgroundColor: tooltipBg, color: fontColor, border: `1px solid ${fontColor}` }} itemStyle={{ color: fontColor }} labelStyle={{ color: fontColor }} />
            <Area type="monotone" dataKey="uv" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
            <Area type="monotone" dataKey="pv" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div style={{ width: "100%", height: 300, marginTop: 40 }}>
        <Typography variant="h6" gutterBottom>Pie Chart</Typography>
        <ResponsiveContainer>
          <PieChart>
            <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip contentStyle={{ backgroundColor: tooltipBg, color: fontColor, border: `1px solid ${fontColor}` }} itemStyle={{ color: fontColor }} labelStyle={{ color: fontColor }} />
            <Legend wrapperStyle={{ color: fontColor }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RechartsTestPage;